import { Mapper } from '../../../../base/utils/mapper';
import {
  JITMeetTeleconsultaEstado,
  JITMeetTeleconsultaModel,
} from '../../../../domain/models/jit-meet/jit-meet-teleconsulta.model';
import { JITMeetTeleconsultaEntity } from '../entities/jit-meet-teleconsulta.entity';

export class JITMeetTeleconsultaRepositoryMapper extends Mapper<
  JITMeetTeleconsultaEntity,
  JITMeetTeleconsultaModel
> {
  mapFrom(param: JITMeetTeleconsultaEntity): JITMeetTeleconsultaModel {
    return {
      ...param,
      data: param.data
        ? {
            ...param.data,
            estado: param.data.estado as JITMeetTeleconsultaEstado,
          }
        : null,
    };
  }

  mapTo(param: JITMeetTeleconsultaModel): JITMeetTeleconsultaEntity {
    return {
      ...param,
      data: param.data ? { ...param.data, estado: Number(param.data.estado) } : null,
    };
  }
}
